import styles from './Button.module.css';
function Button({text,icon,onClick}) {
    return (<button className={styles.button} onClick={onClick}>
        {icon}
        {text}
    </button>);
}

export default Button;